import { bindable, watch } from "aurelia"
import { segmentImages } from "../../data"
import { IFormInputOption } from "@components/form/interfaces/form-interface"
import { CurrentFile, IStep } from "../../brand-guide-page"

export class PostExampleComponent {
  private segmentImages = segmentImages
  private currentFileUrl: CurrentFile
  @bindable brandName: string
  // @bindable brandSegmentValue: string
  @bindable brandSegment: IFormInputOption
  @bindable backgroundColor: string
  @bindable accentColor: string
  @bindable foregroundColor: string
  @bindable postDescription: string
  @bindable currentFile: File
  @bindable logoFileId: string
  @bindable currentStep: number
  @bindable steps: IStep[]

  @watch('currentFile')
  handleCurrentFileChange() {
    if (this.currentFile) {

      const fileReader = new FileReader();

      fileReader.onloadend = () => {
        const base64Data = fileReader.result as string;

        const fileId = Math.random().toString(36).substring(2, 9);

        const fileData: CurrentFile = {
          id: fileId,
          file: base64Data,
          size: this.currentFile.size,
        }

        this.currentFileUrl = fileData
      }

      if (this.currentFile) {
        fileReader.readAsDataURL(this.currentFile);
      }

    }
  }

}